import { render, staticRenderFns } from "./SideDisplay.vue?vue&type=template&id=160e8a00&scoped=true&"
import script from "./SideDisplay.vue?vue&type=script&lang=js&"
export * from "./SideDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SideDisplay.vue?vue&type=style&index=0&id=160e8a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e8a00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VLayout})
